import React from "react";
import styled from "styled-components";
import { theme } from "../styles/theme";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PieChartIcon from "@mui/icons-material/PieChart";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import HandshakeIcon from "@mui/icons-material/Handshake";
import ReceiptIcon from "@mui/icons-material/Receipt";

const FutureSection = styled.section`
  padding: 5rem 0;
  background: linear-gradient(
    135deg,
    ${theme.colors.primary},
    ${theme.colors.secondary}
  );
  color: ${theme.colors.white};
  position: relative;
  overflow: hidden;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
  }

  h2 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    text-align: center;

    @media (max-width: ${theme.breakpoints.mobile}) {
      font-size: 2rem;
    }
  }

  p {
    font-size: 1.1rem;
    max-width: 700px;
    margin: 0 auto 3rem;
    text-align: center;
    opacity: 0.9;
  }
`;

const FutureGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;

  @media (max-width: ${theme.breakpoints.mobile}) {
    grid-template-columns: 1fr;
  }
`;

const FutureCard = styled.div`
  background-color: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 15px;
  padding: 2rem;
  transition: all 0.3s ease;
  height: 100%;
  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-10px);
    background-color: rgba(255, 255, 255, 0.15);
  }

  .icon {
    width: 60px;
    height: 60px;
    background-color: rgba(255, 255, 255, 0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 1.5rem;
    font-size: 1.5rem;

    svg {
      font-size: 1.8rem;
    }
  }

  h3 {
    font-size: 1.4rem;
    margin-bottom: 1rem;
  }

  p {
    opacity: 0.9;
    line-height: 1.6;
    margin-bottom: 0;
    text-align: left;
  }

  .coming-soon {
    margin-top: auto;
    padding-top: 1rem;
    font-size: 0.9rem;
    opacity: 0.7;
    font-style: italic;
  }
`;

const FutureDevelopments = () => {
  return (
    <FutureSection id="future">
      <div className="container">
        <h2>Future Developments</h2>
        <p>
          We're constantly innovating to bring you new solutions that will
          transform how you interact with technology and manage your finances.
        </p>

        <FutureGrid>
          <FutureCard>
            <div className="icon">
              <CreditCardIcon />
            </div>
            <h3>Payment Gateway Integration</h3>
            <p>
              A comprehensive payment solution for businesses of all sizes.
              Accept payments from customers worldwide with our secure and
              reliable payment gateway.
            </p>
            <div className="coming-soon">Coming Soon</div>
          </FutureCard>

          <FutureCard>
            <div className="icon">
              <PieChartIcon />
            </div>
            <h3>Financial Analytics Dashboard</h3>
            <p>
              Gain valuable insights into your financial data with our advanced
              analytics dashboard. Make informed decisions based on real-time
              data and trends.
            </p>
            <div className="coming-soon">Coming Soon</div>
          </FutureCard>

          <FutureCard>
            <div className="icon">
              <AccountBalanceWalletIcon />
            </div>
            <h3>Digital Wallet Solution</h3>
            <p>
              A secure and convenient digital wallet for all your payment needs.
              Store multiple payment methods, track transactions, and manage
              your finances in one place.
            </p>
            <div className="coming-soon">Coming Soon</div>
          </FutureCard>

          <FutureCard>
            <div className="icon">
              <MonetizationOnIcon />
            </div>
            <h3>Investment Platform</h3>
            <p>
              An intuitive platform for both beginners and experienced
              investors. Access a wide range of investment opportunities with
              expert guidance and tools.
            </p>
            <div className="coming-soon">Coming Soon</div>
          </FutureCard>

          <FutureCard>
            <div className="icon">
              <HandshakeIcon />
            </div>
            <h3>Peer-to-Peer Lending</h3>
            <p>
              Connect borrowers with lenders directly through our secure
              platform. Benefit from competitive rates and flexible terms for
              all your lending needs.
            </p>
            <div className="coming-soon">Coming Soon</div>
          </FutureCard>

          <FutureCard>
            <div className="icon">
              <ReceiptIcon />
            </div>
            <h3>Invoice Management System</h3>
            <p>
              Streamline your invoicing process with our automated system.
              Create, send, and track invoices effortlessly to improve your cash
              flow.
            </p>
            <div className="coming-soon">Coming Soon</div>
          </FutureCard>
        </FutureGrid>
      </div>
    </FutureSection>
  );
};

export default FutureDevelopments;
